"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SEARCH : SEARCH RESULT NAV : STYLES --------------- ++++++++++ */


var _default = {
  searchresultnav: {
    display: function display(props) {
      return props.visible ? 'flex' : 'none';
    },
    alignItems: 'center',
    '& .resultCount': {
      fontSize: (0, _index.pxToEm)(10)
    },
    '& .clearResults': {
      margin: "0 ".concat((0, _index.pxToEm)(8)),
      '& .icon': {
        margin: 0,
        fontSize: (0, _index.pxToEm)(22)
      }
    },
    '& .resultnav': {
      display: 'flex',
      '& .arrow': {
        width: (0, _index.pxToEm)(35),
        border: (0, _index.replacePXinStringWithEM)("1px solid #ecf0f7"),
        borderRadius: (0, _index.pxToEm)(4),
        background: _index.theme.color.light.light.swatch,
        '& .link': {
          width: '100%',
          display: 'block',
          textAlign: 'center',
          '& .inner': {
            width: '100%'
          }
        },
        '& .icon': {
          margin: 0,
          lineHeight: (0, _index.pxToEm)(37),
          fontSize: (0, _index.pxToEm)(20)
        }
      }
    }
  }
};
exports.default = _default;